import fixedHeader from './modules/fixedHeader.js';
import scrollReveal from './modules/scrollReveal.js';
import mobileNav from './modules/mobileNav.js';
import booking from './modules/booking.js';
import roomsFilter from './modules/roomsFilter.js';
import menuTabs from './modules/menuTabs.js';
import datePicker from './modules/datePicker.js';
import phoneMask from './modules/phoneMask.js';
import gallery from './modules/gallery.js';
import roomGallery from './modules/roomGallery.js';
import 'glightbox/dist/css/glightbox.min.css';

document.addEventListener('DOMContentLoaded', () => {
  fixedHeader();
  scrollReveal();
  mobileNav();
  booking();
  roomsFilter();
  menuTabs();
  datePicker();
  phoneMask();
  gallery();
  roomGallery();
  // Форми (столик, контакти, заявка на номер) — на Contact Form 7:
  // валідацію/AJAX/повідомлення робить він сам, власного JS не треба.
});
